module.exports = __webpack_public_path__ + "img/namsan_gallery0.54e17af4.jpg";